module.exports = __webpack_public_path__ + "static/media/abzug_lampe_rot.1535f912.jpg";